var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "currentColor",
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.667 3.335a.832.832 0 0 0-.832.832v11.666a.832.832 0 0 0 .832.832H8a.835.835 0 1 1 0 1.67H4.667a2.502 2.502 0 0 1-2.502-2.502V4.167a2.502 2.502 0 0 1 2.502-2.502H8a.835.835 0 1 1 0 1.67H4.667Zm8.576 1.908a.835.835 0 0 1 1.18 0L18.59 9.41a.835.835 0 0 1 0 1.18l-4.166 4.167a.835.835 0 1 1-1.181-1.18l2.741-2.742H8a.835.835 0 0 1 0-1.67h7.984l-2.741-2.741a.835.835 0 0 1 0-1.181Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/Exit.807ad0a609cf697ff71f1a3e5c84df51.svg";
export { ForwardRef as ReactComponent };